import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { spacing } from 'styles/globals';
import useInterval from 'hooks/useInterval';
import Card from 'components/Card';
import Icon from 'components/Icon';
import Flag from 'components/Flag';
import Text from 'components/Text';
import VisuallyHidden from 'components/VisuallyHidden';
import Readout from './Readout';
var Wrapper = styled(Card).withConfig({
  displayName: "UserProgress__Wrapper",
  componentId: "sc-tvuuh4-0"
})(["display:inline-block;vertical-align:top;width:auto;flex-shrink:0;padding:", ";padding-right:", ";text-align:left;transform:translateZ(0);"], spacing.s, spacing.l);
var FadingFlag = styled(Flag).withConfig({
  displayName: "UserProgress__FadingFlag",
  componentId: "sc-tvuuh4-1"
})(["will-change:opacity,transform;transition:all 350ms ease;opacity:0;transform:translateX(-0.3rem);&.isVisible{opacity:1;transform:translateX(0);transition-delay:200ms;}&.isVisible ~ &{opacity:0;transform:translateX(0.3rem);}& + &{margin-top:-3.0625rem;}"]);
var BigIcon = styled(Icon).withConfig({
  displayName: "UserProgress__BigIcon",
  componentId: "sc-tvuuh4-2"
})(["font-size:2.5rem;opacity:", ";"], function (p) {
  return p.theme.textDimStrength;
});
function getDecimalHours(totalMinutes) {
  return Math.round(totalMinutes / 60 * 10) / 10;
}
var LearningProgress = function LearningProgress(_ref) {
  var assetCount = _ref.assetCount,
    totalMinutes = _ref.totalMinutes;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var headingId = 'learning-progress-heading';

  // Switch view every 5 seconds
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    viewIndex = _useState2[0],
    setViewIndex = _useState2[1];
  useInterval(function () {
    setViewIndex(function (previousIndex) {
      return previousIndex === 0 ? 1 : 0;
    });
  }, 5000);
  return /*#__PURE__*/React.createElement(Wrapper, {
    forwardedAs: "aside",
    "aria-labelledby": headingId
  }, /*#__PURE__*/React.createElement(VisuallyHidden, {
    as: "h2",
    id: headingId
  }, t('learning_progress_headline')), /*#__PURE__*/React.createElement(FadingFlag, {
    className: viewIndex === 0 ? 'isVisible' : '',
    token: /*#__PURE__*/React.createElement(BigIcon, {
      dimmed: true,
      name: "time"
    })
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('learning_progress_you_have_completed')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Readout, {
    bold: true,
    value: getDecimalHours(totalMinutes)
  }, t('hours_of_learning'))), /*#__PURE__*/React.createElement(FadingFlag, {
    className: viewIndex === 1 ? 'isVisible' : '',
    token: /*#__PURE__*/React.createElement(BigIcon, {
      dimmed: true,
      name: "ok"
    })
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('learning_progress_you_have_completed')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Readout, {
    bold: true,
    value: assetCount
  }, t('content_type_asset', {
    count: assetCount
  }))));
};
export default LearningProgress;